import React from 'react';
import {Route} from 'react-router';
import Header from './header';
import Sidebar from './sidebar';
import PageHeader from './pageheader';
import useWindowWidth from '../hook/useWindowWidth';
import Footer from './footer';

export default ({component: Component, ...rest}) => {
  const width = useWindowWidth();
  return (
    <Route
      {...rest}
      render={matchProps => (
        <>
          <div className="kt-grid kt-grid--hor kt-grid--root">
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
              <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
                <Header />
                <div className="kt-container kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-grid--stretch">
                  <Sidebar />
                  <div className="kt-holder kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                      <div
                        style={{
                          height: 'calc(100vh - 101px)',
                          minHeight: '720px',
                        }}
                      >
                        <div
                          style={{
                            overflow: 'hidden',
                            height: width > 768 && '100%',
                          }}
                        >
                          <PageHeader
                            title={rest.title}
                            {...rest}
                            {...matchProps}
                          />
                          <div
                            className="kt-content kt-grid__item kt-grid__item--fluid"
                            style={{height: '100%'}}
                          >
                            <div
                              className={`kt-portlet ${rest.className}`}
                              style={{height: '100%'}}
                            >
                              {rest.subtitle && (
                                <div className="kt-portlet__head">
                                  <div className="kt-portlet__head-label">
                                    <h3 className="kt-portlet__head-title">
                                      {rest.subtitle}
                                    </h3>
                                  </div>
                                </div>
                              )}
                              <div
                                className="kt-portlet__body"
                                style={{height: '85%'}}
                              >
                                <Component {...matchProps} />
                              </div>
                            </div>
                            {width <= 768 && <Footer />}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="skincare-configuration-footer">
              {width > 768 && <Footer />}
            </div>
          </div>
        </>
      )}
    />
  );
};
